import { render } from "./TheCrosshair.vue?vue&type=template&id=3fd915eb&scoped=true&ts=true"
import script from "./TheCrosshair.vue?vue&type=script&lang=ts"
export * from "./TheCrosshair.vue?vue&type=script&lang=ts"

import "./TheCrosshair.vue?vue&type=style&index=0&id=3fd915eb&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd915eb"]])

export default __exports__